import { defineComponent as m, openBlock as t, createElementBlock as o, mergeProps as s, unref as H, renderSlot as A, createElementVNode as e, createCommentVNode as d } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, h = { key: 1 }, u = { key: 2 }, g = { key: 3 }, M = { key: 4 }, f = { key: 5 }, v = {
  name: "ScalarIconCreditCard"
}, y = /* @__PURE__ */ m({
  ...v,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const V = l, { bind: r, weight: n } = i(V);
    return (Z, a) => (t(), o("svg", s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, H(r)), [
      A(Z.$slots, "default"),
      H(n) === "bold" ? (t(), o("g", p, a[0] || (a[0] = [
        e("path", { d: "M224,44H32A20,20,0,0,0,12,64V192a20,20,0,0,0,20,20H224a20,20,0,0,0,20-20V64A20,20,0,0,0,224,44Zm-4,24V88H36V68ZM36,188V112H220v76Zm172-24a12,12,0,0,1-12,12H164a12,12,0,0,1,0-24h32A12,12,0,0,1,208,164Zm-68,0a12,12,0,0,1-12,12H116a12,12,0,0,1,0-24h12A12,12,0,0,1,140,164Z" }, null, -1)
      ]))) : H(n) === "duotone" ? (t(), o("g", h, a[1] || (a[1] = [
        e("path", {
          d: "M232,96v96a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V96Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,16V88H32V64Zm0,128H32V104H224v88Zm-16-24a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h32A8,8,0,0,1,208,168Zm-64,0a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h16A8,8,0,0,1,144,168Z" }, null, -1)
      ]))) : H(n) === "fill" ? (t(), o("g", u, a[2] || (a[2] = [
        e("path", { d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM136,176H120a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm64,0H168a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM32,88V64H224V88Z" }, null, -1)
      ]))) : H(n) === "light" ? (t(), o("g", g, a[3] || (a[3] = [
        e("path", { d: "M224,50H32A14,14,0,0,0,18,64V192a14,14,0,0,0,14,14H224a14,14,0,0,0,14-14V64A14,14,0,0,0,224,50ZM32,62H224a2,2,0,0,1,2,2V90H30V64A2,2,0,0,1,32,62ZM224,194H32a2,2,0,0,1-2-2V102H226v90A2,2,0,0,1,224,194Zm-18-26a6,6,0,0,1-6,6H168a6,6,0,0,1,0-12h32A6,6,0,0,1,206,168Zm-64,0a6,6,0,0,1-6,6H120a6,6,0,0,1,0-12h16A6,6,0,0,1,142,168Z" }, null, -1)
      ]))) : H(n) === "regular" ? (t(), o("g", M, a[4] || (a[4] = [
        e("path", { d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,16V88H32V64Zm0,128H32V104H224v88Zm-16-24a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h32A8,8,0,0,1,208,168Zm-64,0a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h16A8,8,0,0,1,144,168Z" }, null, -1)
      ]))) : H(n) === "thin" ? (t(), o("g", f, a[5] || (a[5] = [
        e("path", { d: "M224,52H32A12,12,0,0,0,20,64V192a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V64A12,12,0,0,0,224,52ZM32,60H224a4,4,0,0,1,4,4V92H28V64A4,4,0,0,1,32,60ZM224,196H32a4,4,0,0,1-4-4V100H228v92A4,4,0,0,1,224,196Zm-20-28a4,4,0,0,1-4,4H168a4,4,0,0,1,0-8h32A4,4,0,0,1,204,168Zm-64,0a4,4,0,0,1-4,4H120a4,4,0,0,1,0-8h16A4,4,0,0,1,140,168Z" }, null, -1)
      ]))) : d("", !0)
    ], 16));
  }
});
export {
  y as default
};
